<template>
  <listTemplate :class="['height__100vh', 'scrollable-dialog']">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div
            class="header-title wrapper-content__main font-size__large font-weight__bold"
          >
            Công việc trọng tâm
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection flex-row">
                  <el-button
                    size="small"
                    type="success"
                    v-if="isTonghopBaoCao"
                    @click="openCreateDialog"
                    class="margin-right-10"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-plus-circle font-size__medium"></i>
                      <span>&nbsp;&nbsp;Thêm mới</span>
                    </div>
                  </el-button>

                  <el-button-group class="flex-row">
                    <el-button
                      size="medium"
                      type="primary"
                      @click="openTrongTamReportDialog"
                      v-if="isAbleToExportReport"
                    >
                      Xuất báo cáo
                    </el-button>
                  </el-button-group>
                </div>

                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #advance>
                    <hc-command-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      v-if="isEnableAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    >
                    </hc-command-advance-search-dialog>
                  </template>
                </searchTemplate>
              </template>
            </sub-header>
          </template>

          <template #body>
            <template>
              <div class="barChart" ref="barChartContainerDiv">
                <el-table
                  v-if="rerenderFlag"
                  :data="items"
                  class="style-fullWidth"
                  highlight-current-row
                  :height="chartSize.height"
                  sortable="custom"
                  @sort-change="doSort"
                  @row-click="viewDetail"
                >
                  <el-table-column type="index" fixed></el-table-column>

                  <el-table-column property="state" min-width="40" fixed>
                    <template slot-scope="scope">
                      <hc-command-state-icon :state="scope.row.state" />
                    </template>
                  </el-table-column>

                  <!-- Trường cũ Cuộc họp -->
                  <el-table-column
                    property="meeting"
                    label="Tiêu đề"
                    min-width="300"
                    fixed
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.meeting"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="performFullName"
                    label="LĐ phụ trách"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.performFullName"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <!-- Trường cũ LĐ Chỉ đạo -->
                  <el-table-column
                    property="directiveFullName"
                    label="Đơn vị chủ trì"
                    min-width="200"
                    sortable
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.deptName"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    label=" Ngày chỉ đạo"
                    property="commandsDate"
                    min-width="120"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                        scope.row.commandsDate
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <!-- Trường cũ Hạn hoàn thành -->
                  <el-table-column
                    label="Hạn xử lý"
                    property="deadline"
                    min-width="140"
                    sortable
                  >
                    <template slot-scope="scope">
                      <span>{{
                          getLastestDeadline(scope.row.deadline, scope.row.nextDeadline, scope.row.nextDeadline2)
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    property="conclusion"
                    label="Nội Dung Công Việc"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.conclusion"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>

                  <!-- Trường cũ Hạn Nội dung -->
                  <el-table-column
                    property="note"
                    label="Ghi chú"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <break-word-span
                        :text="scope.row.note"
                        :maxLength="100"
                      ></break-word-span>
                    </template>
                  </el-table-column>


                  <el-table-column
                    property="commandsStatus"
                    min-width="120"
                    label="Tiến độ xử lý"
                  >
                    <template slot-scope="scope">
                      <hc-command-status
                        :commandsStatus="scope.row.commandsStatus"
                      />
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="updateTime"
                    label="Ngày cập nhật"
                    min-width="140"
                    sortable
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{
                        scope.row.updateTime
                          | dateFormatter({
                            dateFormat: "DD/MM/YYYY",
                            nullValue: "-"
                          })
                      }}</span>
                    </template>
                  </el-table-column>

                  <infinite-loading
                    slot="append"
                    @infinite="infiniteHandler"
                    force-use-infinite-wrapper=".el-table__body-wrapper"
                    ref="infiniteLoading"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results"></div>
                  </infinite-loading>
                </el-table>
              </div>
            </template>
          </template>
        </list-template>
      </div>
<!-- thêm mới -->
      <hc-command-create-dialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        :flowId="flowId"
        :flowCode="flowCode"
        :parentDeptId="parentDeptId"
        @dialogClosed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @insertSuccess="createDialogSuccess"
      />
<!-- báo cáo trọng tâm -->
      <hc-trong-tam-report-dialog
        :isOpen="isOpenDialogReport_TT"
        v-if="isEnableDialogReport_TT"
        @dialogClosed="isEnableDialogReport_TT = false"
        @closeDialog="isOpenDialogReport_TT = false"
        :inputForm="reportInputForm"
        :inputPageable="reportPageable"
        :parentDeptId="parentDeptId"
      />
    </template>
  </listTemplate>
</template>

<script>
import headerTemplate from "../../../components/header/main-header.vue";
import menuConfigService from "../../../services/menuConfigService";
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search";
import HcTrongTamReportDialog from "../../report/congviectrongtam/hc-congviectrongtam-report-dialog.vue";
// import mainContent from "./ketLuanChiDao_MainContent";
import utils from "../../../services/utils";
import h from "../../../services/h";
import hanhchinhService from "../../../services/hanhchinhService";
import hcCongViecTrongTamSearchViewService from "../../../services/congviectrongtam/hcCVTrongTamSearchViewService";
import HcCommandStateIcon from "../ketluan/hc-command-state-icon";
import HcCommandStatus from "../ketluan/hc-command-status";
import HcCommandProgress from "../ketluan/hc-command-progress";
import dateFormatter from "../../../filters/dateFormatter";
import BreakWordSpan from "../ketluan/break-word-span";
import HcCommandAdvanceSearchDialog from "./hc-congviectrongtam-advance-search-dialog-cvTrongTam.vue";
import HcCommandCreateDialog from "./hc-congviectrongtam-create-dialog-2.vue";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import goBackMixin from "../../../mixins/goBackMixin";
import SubHeader from "../../../components/main/sub-header";
import categoryViewService from "../../../services/categoryViewService";
import constants from "../../../constants";

export default {
  mixins: [goBackMixin],
  components: {
    HcTrongTamReportDialog,
    SubHeader,
    HcCommandCreateDialog,
    HcCommandAdvanceSearchDialog,
    BreakWordSpan,
    HcCommandProgress,
    HcCommandStatus,
    HcCommandStateIcon,
    headerTemplate,
    searchTemplate,
    listTemplate,
    // mainContent
  },
  filters: { dateFormatter },

  data() {
    return {
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      isOpenDialogReport: false,
      isEnableDialogReport: false, //báo cáo chi tiết;
      isOpenDialogReport_TT: false,
      isEnableDialogReport_TT: false, //báo cáo trọng tâm;
      reportInputForm: null,
      reportTHInputForm: null,
      reportPageable: null,

      selectdItem: null,
      flowId: null,
      hcFlow: null,
      flowCode: "CONG_VIEC_TRONG_TAM",

      advanceSearchForm: null,
      items: [],
      page: 0,
      size: 10,
      sort: "updateTime",
      order: "desc",
      keyword: null,
      chartSize: {
        width: 100,
        height: 100
      },
      rerenderFlag: false,
      sectorCategories: null,
      isAbleToExportReport: null,
      // isAbleToExportTHReport: null
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    // isTongHopBaoCaoRole() {
    //   return (
    //     this.userDeptRole &&
    //     this.userDeptRole.roleCode === constants.ROLE.CODE.TONG_HOP_BAO_CAO
    //   );
    // },

    deptId() {
      return this.userDeptRole ? this.userDeptRole.deptId : null;
    },

    parentDeptId() {
      let userDeptRole = h.find(
        this.$store.state.userDeptRoles,
        userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
      );
      return userDeptRole.parentDeptId;
    },

    // childDeptId() {
    //   let userDeptRole = h.find(
    //     this.$store.state.userDeptRoles,
    //     userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
    //   );
    //   return userDeptRole.deptId;
    // }

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    isTonghopBaoCao() {
      return this.$store.getters.userDeptRole && this.$store.getters.userDeptRole.roleCode === constants.ROLE.CODE.TONG_HOP_BAO_CAO;
    }
  },

  watch: {
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },

    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },

    isOpenDialogReport(newValue) {
      newValue && (this.isEnableDialogReport = newValue);
    },

    isOpenDialogReport_TT(newValue) {
      newValue && (this.isEnableDialogReport_TT = newValue);
    },

    isEnableDialogCreate(newValue) {
      !newValue && (this.selectdItem = null);
    }
  },

  created() {
    if (!this.userDeptRoleId) return;
    this.loadSectorCategories();
    this.getProcedureInformation();
    this.initQuery();
    this.registerEventBusForMaster(event => this.doSearch());
    this.initActions();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  mounted() {
    this.calculateChartSize();
    this.rerenderFlag = true;
  },

  methods: {
    initActions() {
      return Promise.all([
        menuConfigService
          .isEnableMenu(
            this.userDeptRoleId,
            constants.MENU_LIST.BAOCAO_HC_CONG_VIEC_TRONG_TAM
          )
          .then(isAccessible => (this.isAbleToExportReport = isAccessible)),
        // menuConfigService
        //   .isEnableMenu(
        //     this.userDeptRoleId,
        //     constants.MENU_LIST.BAOCAO_HC_CHI_DAO_TONG_HOP
        //   )
        //   .then(isAccessible => (this.isAbleToExportTHReport = isAccessible))
      ]);
    },

    openTrongTamReportDialog() {
      // console.log(this.advanceSearchForm.sector);
      //convert tham số lọc sang phần report;
      this.reportInputForm = {
        fromCommandsDate: this.advanceSearchForm.startTimeCommand,
        toCommandsDate: this.advanceSearchForm.endTimeCommand,
        performDepartmentIds: null,
      };
      this.reportPageable = { sort: this.sort, order: this.order };
      this.isOpenDialogReport_TT = true;
    },

    loadSectorCategories() {
      return categoryViewService
        .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.HC_COMMAND_SECTOR)
        .then(response => (this.sectorCategories = response.data));
    },

    getProcessTypeLabel(processType) {
      return hanhChinhUtils.getHcCommandProcessTypeLabel(processType);
    },

    // getSectorLabel(sector) {
    //   return hanhChinhUtils.getHcCommandSectorName(
    //     sector,
    //     this.sectorCategories
    //   );
    // },

    openCreateDialog() {
      this.isOpenDialogCreate = true;
    },

    calculateChartSize() {
      this.chartSize.width = this.$refs.barChartContainerDiv.clientWidth;
      this.chartSize.height = this.$refs.barChartContainerDiv.clientHeight;
    },

    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        meeting: this.$route.query.meeting || undefined,
        sector: this.$route.query.sector || undefined,
        conclusion: this.$route.query.conclusion || undefined,
        note: this.$route.query.note || undefined,
        directiveId: this.$route.query.directiveId || undefined,
        performId: this.$route.query.performId || undefined,
        deptId: this.$route.query.deptId || undefined,
        progress: this.$route.query.progress || undefined,
        state: this.$route.query.state || undefined,
        commandsStatus: this.$route.query.commandsStatus || undefined,

        startTimeCommand: this.$route.query.startTimeCommand
          ? parseInt(this.$route.query.startTimeCommand)
          : undefined,
        endTimeCommand: this.$route.query.endTimeCommand
          ? parseInt(this.$route.query.endTimeCommand)
          : undefined,
        startTimeDeadline: this.$route.query.startTimeDeadline
          ? parseInt(this.$route.query.startTimeDeadline)
          : undefined,
        endTimeDeadline: this.$route.query.endTimeDeadline
          ? parseInt(this.$route.query.endTimeDeadline)
          : undefined,
        startTimeFinish: this.$route.query.startTimeFinish
          ? parseInt(this.$route.query.startTimeFinish)
          : undefined,
        endTimeFinish: this.$route.query.endTimeFinish
          ? parseInt(this.$route.query.endTimeFinish)
          : undefined
      };

      this.keyword = this.advanceSearchForm.meeting;
    },

    buildQuery() {
      return utils.merge(
        { sort: this.sort, order: this.order },
        this.advanceSearchForm
      );
    },

    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.meeting = keyword;
      // this.advanceSearchForm.sector = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.conclusion = undefined;
      this.advanceSearchForm.note = undefined;
      this.advanceSearchForm.directiveId = undefined;
      this.advanceSearchForm.performId = undefined;
      this.advanceSearchForm.deptId = undefined;
      this.advanceSearchForm.progress = undefined;
      this.advanceSearchForm.state = undefined;
      this.advanceSearchForm.commandsStatus = undefined;
      this.advanceSearchForm.startTimeCommand = undefined;
      this.advanceSearchForm.endTimeCommand = undefined;
      this.advanceSearchForm.startTimeDeadline = undefined;
      this.advanceSearchForm.endTimeDeadline = undefined;
      this.advanceSearchForm.startTimeFinish = undefined;
      this.advanceSearchForm.endTimeFinish = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.keyword = this.advanceSearchForm.meeting = advanceSearchForm.meeting;
      this.advanceSearchForm.sector = advanceSearchForm.sector || undefined;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.conclusion =
        advanceSearchForm.conclusion || undefined;
      this.advanceSearchForm.note =
        advanceSearchForm.note || undefined;
      this.advanceSearchForm.directiveId =
        advanceSearchForm.directiveId || undefined;
      this.advanceSearchForm.performId =
        advanceSearchForm.performId || undefined;
      this.advanceSearchForm.deptId = advanceSearchForm.deptId || undefined;
      this.advanceSearchForm.progress = advanceSearchForm.progress || undefined;
      this.advanceSearchForm.state = advanceSearchForm.state || undefined;
      this.advanceSearchForm.commandsStatus =
        advanceSearchForm.commandsStatus || undefined;
      this.advanceSearchForm.startTimeCommand =
        advanceSearchForm.startTimeCommand || undefined;
      this.advanceSearchForm.endTimeCommand =
        advanceSearchForm.endTimeCommand || undefined;
      this.advanceSearchForm.startTimeDeadline =
        advanceSearchForm.startTimeDeadline || undefined;
      this.advanceSearchForm.endTimeDeadline =
        advanceSearchForm.endTimeDeadline || undefined;
      this.advanceSearchForm.startTimeFinish =
        advanceSearchForm.startTimeFinish || undefined;
      this.advanceSearchForm.endTimeFinish =
        advanceSearchForm.endTimeFinish || undefined;
      this.advanceSearchForm.directiveIds = advanceSearchForm.directiveIds || undefined;
      this.advanceSearchForm.performIds = advanceSearchForm.performIds || undefined;
      this.doSearch();
    },

    doSort(event) {
      this.sort = event.prop;
      switch (event.order) {
        case "ascending":
          this.order = "asc";
          break;
        case "descending":
          this.order = "desc";
          break;
        default:
          this.order = null;
      }
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.items = [];
      this.page = 0;
      this.$nextTick(() => {
        this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset();
      });
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      return this.listIfHasTongHopBaoCaoRole(pageable).then(response => {
        let items = []
        items = response.data;
        items && this.items.push(...items);
        console.log('this.items')
        console.log(this.items)
        return items;
      });
    },

    listIfHasTongHopBaoCaoRole(pageable) {
      return hcCongViecTrongTamSearchViewService.findAll(
        this.advanceSearchForm,
        pageable
      );
    },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then(response => {
          if (response.data.hcFlow !== null) {
            this.hcFlow = response.data.hcFlow;
            this.flowId = this.hcFlow.id;
          }
        });
    },

    reloadPage() {
      this.doSearch();
    },

    viewDetail(row, column, event) {
      let caseMasterId = row.caseMasterId;
      let params = utils.merge(this.$route.params, { id: caseMasterId });
      this.$router.push({
        name: "adminstration-bcCVTrongTamDetail",
        params: params,
        query: this.$route.query
      });
    },

    closeDialog() {
      this.isOpenDialogCreate = false;
    },

    createDialogSuccess() {
      this.isOpenDialogCreate = false;
      this.reloadPage();
    },

    getLastestDeadline(deadline, nextDeadline, nextDeadline2) {
      let lastestDeadline = null;
      if (nextDeadline2) {
        console.log('nextDeadline2', nextDeadline2)
        lastestDeadline = nextDeadline2;
      } else if (nextDeadline) {
        console.log('nextDeadline', nextDeadline)
        lastestDeadline = nextDeadline;
      } else {
        console.log('deadline', deadline)
        lastestDeadline = deadline
      }
      console.log('---------lastestDeadline', lastestDeadline)
      return lastestDeadline;
    }
  }
};
</script>

<style scoped>
.barChart {
  margin-top: 20px;
  height: calc(100% - 100px) !important;
  width: calc(100% - 10px) !important;
  position: relative;
}

.break-word {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/congviectrongtam/bcCVTrongTam_Index.vue